import clsx from "clsx";
import { ChangeEvent, FC, ReactNode, memo } from "react";

interface Props {
  id?: string;
  name?: string;
  label?: string | ReactNode;
  containerClassName?: string;
  radioClassName?: string;
  labelClassName?: string;
  isDisabled?: boolean;
  value?: string | number;
  checked?: boolean;
  onChange?: (event: string | number | undefined) => void;
  children?: ReactNode;
}

/**
 * Basicな共通のラジオボタンです。
 * @param props
 * @returns
 */
const RadioBase: FC<Props> = ({
  id,
  name,
  label,
  containerClassName,
  radioClassName,
  labelClassName,
  isDisabled = false,
  value,
  checked,
  onChange,
  children,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement> | undefined) => {
    onChange?.(event?.target?.value);
  };
  const classBase =
    "flex flex-col items-center border rounded-[4px] cursor-pointer px-[14px] py-[12px] hover:border-[#3ABCA8] cursor-pointer break-word";
  const radioClassNames = clsx(
    "w-[20px] h-[20px] mr-[10px]",
    {
      "!cursor-default": isDisabled,
    },
    radioClassName,
  );
  const labelClassNames = [
    labelClassName,
    "form-check-label inline-block cursor-pointer text-base leading-[16px] !text-[#1A1A1C] break-word",
    isDisabled ? "text-theme-medium !cursor-default" : "text-theme",
  ].join(" ");

  const statusClass = checked
    ? "bg-[#ECFAF7] border-[#3ABCA8]"
    : "border-[#DFDFE2]";

  return (
    <>
      <div
        className={clsx(classBase, statusClass, containerClassName, {
          "hover:border-[#DFDFE2] bg-[#F7F7F7] opacity-80 !cursor-default":
            isDisabled,
        })}
      >
        <label
          className={clsx(
            "flex items-center w-full shrink-0",
            containerClassName,
          )}
          htmlFor={id}
        >
          <input
            className={radioClassNames}
            type="radio"
            name={name}
            id={id}
            disabled={isDisabled}
            value={value}
            onChange={handleChange}
            checked={checked}
          />
          {!!label && (
            <label className={labelClassNames} htmlFor={id}>
              <>{label}</>
            </label>
          )}
        </label>
        {!!children && children}
      </div>
    </>
  );
};

export const RadioCardType = memo(RadioBase);
